import { styled } from '@mui/material';
import Button from "../../button/button";
import { ActionProps } from "react-querybuilder";
import { Add } from "@mui/icons-material";

const StyledAddButton = styled(Button)(({ theme: { palette } }) => ({
  ":hover": {
    backgroundColor: palette.theme?.secondary[100],
  },
  "&.MuiButton-text": {
    ":hover": {
      color: palette.theme?.secondary[1000],
    },
  },
}));

const AddGroupButton = (props: ActionProps) => {
  const { handleOnClick, ...rest } = props;
  return (
    <StyledAddButton
      onClick={handleOnClick}
      {...rest}
      className="add-group"
      variant="text"
      startIcon={<Add/>}
    >
      Add Group
    </StyledAddButton>
  );
};

export { AddGroupButton };
export default AddGroupButton;
